import { z } from "zod";

export const createQuickbooksConnectionBodySchema = z
    .object({
        workspaceId: z.string().uuid().optional(),
        authCode: z.string(),
        realmId: z.string(),
        entityId: z.number().optional(),
        connectionId: z.string().uuid().optional(),
    })
    .superRefine(({ connectionId, entityId, workspaceId }, ctx) => {
        if (
            connectionId !== undefined &&
            (workspaceId === undefined || entityId === undefined)
        ) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message:
                    "workspaceId and entityId are required when connectionId is provided",
                path: ["connectionId"],
            });
        }
    });
